module.exports = __webpack_public_path__ + "img/factory.9cd06e58.svg";